import React, { ReactNode } from 'react';

import { getLivePreviewConfig } from '../setup/configureLivePreview';
import PreviewErrorBoundary, { PreviewMessage } from './PreviewErrorBoundary';

export interface PreviewBlockBoundaryProps {
  typeName: string;
  blockData?: unknown;
  isAddedSinceBuild?: boolean;
  children: ReactNode;
}

export const PreviewBlockBoundary = ({
  typeName,
  blockData,
  isAddedSinceBuild = false,
  children,
}: PreviewBlockBoundaryProps) => {
  const isBuildOnly =
    !!getLivePreviewConfig().buildOnlyBlocks?.includes(typeName);

  const buildOnlyMessage = (
    <>
      <strong>{typeName}</strong> gets part of its content when the site is
      built, and this one was not in the last build. It will appear once it is
      published and the site is rebuilt - the page it sits on does not need to
      be published.
    </>
  );

  if (isBuildOnly && isAddedSinceBuild) {
    return <PreviewMessage>{buildOnlyMessage}</PreviewMessage>;
  }

  return (
    <PreviewErrorBoundary
      name={typeName}
      data={blockData}
      message={
        <>
          <strong>{typeName}</strong> cannot be previewed yet - it is still
          missing content it needs to render.
        </>
      }
    >
      {children}
    </PreviewErrorBoundary>
  );
};
